export const DEFAULT_CALENDLY_LINK =
  "https://calendly.com/d/ygy-j3b-r7t/graphy-demo";

export const UCE_CALENDLY_LINK =
  "https://calendly.com/d/cp37-gbb-3gn/product-demonstration-with-graphy";

export const US_CALENDLY_LINK =
  "https://calendly.com/d/cp37-gbb-3gn/meet-with-graphy-expert";

export const OTHER_COUNTRIES_CALENDLY_LINK =
  "https://calendly.com/d/cp37-gbb-3gn/meet-with-graphy-expert";

  export const UCE_CALENDLY_Affliate = "https://calendly.com/pramit-nandy/graphy-affiliate-program?month=2024-08";

export const KOREAN_CALENDLY_LINK = "https://calendly.com/ankit-sood-kvw/30min";

export const GRAPHY_COMMUNITY_CALENDLY_LINK = "https://calendly.com/debnath-sayani/launch-your-graphy-community/utm_source=websitecommunity"
export const KAJABI_ALTERNATIVE_US_CALENDLY_LINK = "https://calendly.com/debnath-sayani/launch-your-graphy-community/utm_source=websitecommunity"
